
import { ref, toRaw, computed, watch, reactive } from 'vue'
import { setNoEmptyForm } from '@/util/common'
export default () => {
  const searchForm:any = ref({})
  const sortForm: any = reactive({
    ascs: [],
    descs: []
  })
  const filterData = computed(() => {
    if (!sortForm.ascs.length && !sortForm.descs.length) {
      sortForm.descs = []
    }
    return {
      ...setNoEmptyForm(toRaw(searchForm.value)),
      ...sortForm
    }
  })
  return [
    searchForm,
    sortForm,
    filterData
  ]
}
